// eslint-disable-next-line no-undef
IntlPolyfill.__addLocaleData({
  locale: 'pt',
  date: {
    ca: ['gregory', 'generic'],
    hourNo0: true,
    hour12: false,
    formats: {
      short: '{1} {0}',
      medium: '{1} {0}',
      full: '{1} {0}',
      long: '{1} {0}',
      availableFormats: {
        d: 'd',
        E: 'ccc',
        Ed: 'E, d',
        Ehm: 'E, h:mm a',
        EHm: 'E, HH:mm',
        Ehms: 'E, h:mm:ss a',
        EHms: 'E, HH:mm:ss',
        Gy: 'y G',
        GyMMM: "MMM 'de' y G",
        GyMMMd: "d 'de' MMM 'de' y G",
        GyMMMEd: "E, d 'de' MMM 'de' y G",
        h: 'h a',
        H: 'HH',
        hm: 'h:mm a',
        Hm: 'HH:mm',
        hms: 'h:mm:ss a',
        Hms: 'HH:mm:ss',
        hmsv: 'h:mm:ss a v',
        Hmsv: 'HH:mm:ss v',
        hmv: 'h:mm a v',
        Hmv: 'HH:mm v',
        M: 'L',
        Md: 'd/M',
        MEd: 'E, dd/MM',
        MMdd: 'dd/MM',
        MMM: 'LLL',
        MMMd: "d 'de' MMM",
        MMMEd: "E, d 'de' MMM",
        MMMMd: "d 'de' MMMM",
        MMMMEd: "E, d 'de' MMMM",
        ms: 'mm:ss',
        y: 'y',
        yM: 'MM/y',
        yMd: 'dd/MM/y',
        yMEd: 'E, dd/MM/y',
        yMM: 'MM/y',
        yMMM: "MMM 'de' y",
        yMMMd: "d 'de' MMM 'de' y",
        yMMMEd: "E, d 'de' MMM 'de' y",
        yMMMM: "MMMM 'de' y",
        yMMMMd: "d 'de' MMMM 'de' y",
        yMMMMEd: "E, d 'de' MMMM 'de' y",
        yQQQ: 'y QQQ',
        yQQQQ: 'y QQQQ',
      },
      dateFormats: {
        yMMMMEEEEd: "EEEE, d 'de' MMMM 'de' y",
        yMMMMd: "d 'de' MMMM 'de' y",
        yMMMd: "d 'de' MMM 'de' y",
        yMd: 'dd/MM/yy',
      },
      timeFormats: {
        hmmsszzzz: 'HH:mm:ss zzzz',
        hmsz: 'HH:mm:ss z',
        hms: 'HH:mm:ss',
        hm: 'HH:mm',
      },
    },
    calendars: {
      generic: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
          long: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
        },
        days: {
          narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
          short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
          long: [
            'domingo',
            'segunda-feira',
            'terça-feira',
            'quarta-feira',
            'quinta-feira',
            'sexta-feira',
            'sábado',
          ],
        },
        eras: {
          narrow: ['ERA0', 'ERA1'],
          short: ['ERA0', 'ERA1'],
          long: ['ERA0', 'ERA1'],
        },
        dayPeriods: {
          am: 'AM',
          pm: 'PM',
        },
      },
      gregory: {
        months: {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          short: [
            'jan',
            'fev',
            'mar',
            'abr',
            'mai',
            'jun',
            'jul',
            'ago',
            'set',
            'out',
            'nov',
            'dez',
          ],
          long: [
            'janeiro',
            'fevereiro',
            'março',
            'abril',
            'maio',
            'junho',
            'julho',
            'agosto',
            'setembro',
            'outubro',
            'novembro',
            'dezembro',
          ],
        },
        days: {
          narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
          short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
          long: [
            'domingo',
            'segunda-feira',
            'terça-feira',
            'quarta-feira',
            'quinta-feira',
            'sexta-feira',
            'sábado',
          ],
        },
        eras: {
          narrow: ['a.C.', 'd.C.', 'AEC', 'EC'],
          short: ['a.C.', 'd.C.', 'AEC', 'EC'],
          long: [
            'antes de Cristo',
            'depois de Cristo',
            'antes da Era Comum',
            'Era Comum',
          ],
        },
        dayPeriods: {
          am: 'AM',
          pm: 'PM',
        },
      },
    },
  },
  number: {
    nu: ['latn'],
    patterns: {
      decimal: {
        positivePattern: '{number}',
        negativePattern: '{minusSign}{number}',
      },
      currency: {
        positivePattern: '{currency}{number}',
        negativePattern: '{minusSign}{currency}{number}',
      },
      percent: {
        positivePattern: '{number}{percentSign}',
        negativePattern: '{minusSign}{number}{percentSign}',
      },
    },
    symbols: {
      latn: {
        decimal: ',',
        group: '.',
        nan: 'NaN',
        plusSign: '+',
        minusSign: '-',
        percentSign: '%',
        infinity: '∞',
      },
    },
    currencies: {
      AUD: 'AU$',
      BRL: 'R$',
      CAD: 'CA$',
      CNY: 'CN¥',
      EUR: '€',
      GBP: '£',
      HKD: 'HK$',
      ILS: '₪',
      INR: '₹',
      JPY: 'JP¥',
      KRW: '₩',
      MXN: 'MX$',
      NZD: 'NZ$',
      PTE: 'Esc.',
      THB: '฿',
      TWD: 'NT$',
      USD: 'US$',
      VND: '₫',
      XAF: 'FCFA',
      XCD: 'EC$',
      XOF: 'CFA',
      XPF: 'CFPF',
    },
  },
})
